import { p } from "./sectors/_helpers";

/**
 * Cartographie des 9 régions administratives de la Guinée-Bissau
 * (+ SAB, Secteur autonome de Bissau).
 * Chaque région liste ses filières porteuses + une note contextuelle.
 * Coordonnées SVG stylisées (viewBox 100×100) organisées géographiquement.
 */
export const REGIONS = [
 {
 slug: "cacheu",
 name: p("Cacheu", "Cacheu", "Cacheu"),
 capital: "Canchungo",
 filieres: ["cajou", "agriculture", "tourisme", "peche", "logistique"],
 note: p(
 "Cœur de la stratégie NANDA SÁ. Bassin cajou, mangue, riz, mangroves et corridor Bissau-Bafatá.",
 "Heart of NANDA SÁ's strategy. Cashew, mango, rice, mangroves and the Bissau-corridor.",
 "Coração da estratégia NANDA SÁ. Bacia do caju, manga, arroz, mangais e corredor Bissau-Bafatá."
 ),
 // Position approximative (nord-ouest)
 d: "M12,10 L38,8 L42,22 L36,36 L14,34 L8,20 Z",
 },
 {
 slug: "oio",
 name: p("Oio", "Oio", "Oio"),
 capital: "Farim",
 filieres: ["cajou", "agriculture", "logistique"],
 note: p(
 "Grande région productrice de cajou et de riz, ouverte sur les corridors régionaux de la CEDEAO.",
 "Major cashew and rice producing region, backed onto the Bissau-Guinean corridor.",
 "Grande região produtora de caju e arroz, aberta aos corredores regionais da CEDEAO."
 ),
 d: "M38,8 L64,10 L66,26 L60,38 L42,36 L42,22 Z",
 },
 {
 slug: "bafata",
 name: p("Bafatá", "Bafatá", "Bafatá"),
 capital: "Bafatá",
 filieres: ["cajou", "agriculture", "logistique"],
 note: p(
 "Région intérieure, forte productrice de cajou. Position centrale sur les axes est-ouest.",
 "Interior region, major cashew producer. Central position on east-west axes.",
 "Região interior, grande produtora de caju. Posição central nos eixos leste-oeste."
 ),
 d: "M64,10 L88,14 L88,36 L66,36 L66,26 Z",
 },
 {
 slug: "gabu",
 name: p("Gabú", "Gabú", "Gabú"),
 capital: "Gabú",
 filieres: ["cajou", "agriculture", "logistique"],
 note: p(
 "Région orientale frontalière de Guinée-Bissau et de la Guinée. Ouverture CEDEAO majeure.",
 "Eastern region bordering Guinea-Bissau and Guinea. Major ECOWAS opening.",
 "Região oriental fronteiriça com o Guinea-Bissau e a Guiné. Grande abertura CEDEAO."
 ),
 d: "M88,14 L100,20 L100,44 L88,44 L88,36 Z",
 },
 {
 slug: "biombo",
 name: p("Biombo", "Biombo", "Biombo"),
 capital: "Quinhamel",
 filieres: ["agriculture", "peche", "tourisme"],
 note: p(
 "Petite région péninsulaire, périphérie de Bissau. Maraîchage, pêche, tourisme communautaire.",
 "Small peninsular region, on the outskirts of Bissau. Market gardening, fishing, community tourism.",
 "Pequena região peninsular, na periferia de Bissau. Horticultura, pesca, turismo comunitário."
 ),
 d: "M14,34 L36,36 L34,46 L22,50 L8,44 Z",
 },
 {
 slug: "sab",
 name: p("Bissau (SAB)", "Bissau (SAB)", "Bissau (SAB)"),
 capital: "Bissau",
 filieres: ["immobilier", "energie", "logistique", "tourisme"],
 note: p(
 "Capitale et hub économique. Immobilier commercial, hôtellerie, port, entrepôts logistiques.",
 "Capital and economic hub. Commercial real estate, hospitality, port, logistics warehouses.",
 "Capital e hub económico. Imobiliário comercial, hotelaria, porto, armazéns logísticos."
 ),
 d: "M36,36 L60,38 L58,50 L44,52 L34,46 Z",
 },
 {
 slug: "quinara",
 name: p("Quínara", "Quínara", "Quínara"),
 capital: "Buba",
 filieres: ["agriculture", "peche", "energie"],
 note: p(
 "Région sud, dotée d'estuaires exceptionnels. Riziculture, pêche, potentiel solaire élevé.",
 "Southern region with exceptional estuaries. Rice farming, fishing, high solar potential.",
 "Região sul, com estuários excepcionais. Rizicultura, pesca, alto potencial solar."
 ),
 d: "M44,52 L66,52 L66,72 L48,72 L40,62 Z",
 },
 {
 slug: "tombali",
 name: p("Tombali", "Tombali", "Tombali"),
 capital: "Catió",
 filieres: ["agriculture", "peche", "cajou"],
 note: p(
 "Région méridionale, extrême sud du pays. Riziculture, mangroves, cajou en développement.",
 "Southernmost region. Rice cultivation, mangroves, developing cashew.",
 "Região meridional, extremo sul do país. Rizicultura, mangais, caju em desenvolvimento."
 ),
 d: "M48,72 L82,74 L88,88 L60,92 L48,86 Z",
 },
 {
 slug: "bolama",
 name: p("Bolama-Bijagós", "Bolama-Bijagós", "Bolama-Bijagós"),
 capital: "Bolama",
 filieres: ["tourisme", "peche"],
 note: p(
 "Archipel de 88 îles, Réserve de biosphère UNESCO. Écotourisme, pêche, hôtellerie de charme.",
 "88-island archipelago, UNESCO Biosphere Reserve. Ecotourism, fishing, boutique hospitality.",
 "Arquipélago de 88 ilhas, Reserva da Biosfera UNESCO. Ecoturismo, pesca, hotelaria de charme."
 ),
 d: "M8,54 L34,54 L40,72 L28,88 L4,80 Z",
 },
];

export const FILIERES_META = {
 cajou: { fr: "Cajou", en: "Cashew", pt: "Caju", color: "#A66E4E" },
 agriculture: { fr: "Agriculture", en: "Agriculture", pt: "Agricultura", color: "#7A8F5C" },
 energie: { fr: "Énergie", en: "Energy", pt: "Energia", color: "#D4A24E" },
 tourisme: { fr: "Tourisme", en: "Tourism", pt: "Turismo", color: "#5F8AA5" },
 immobilier: { fr: "Immobilier", en: "Real estate", pt: "Imobiliário", color: "#8A6E5F" },
 peche: { fr: "Économie bleue", en: "Blue economy", pt: "Economia azul", color: "#3F6B7A" },
 logistique: { fr: "Logistique", en: "Logistics", pt: "Logística", color: "#6E6E6E" },
};
